import React, {useState, useEffect, useRef} from 'react';
import AppCartItem from "./app.cart.item";
import AppCartInfo from "./app.cart.info";
import {gql, useLazyQuery, useReactiveVar} from "@apollo/client";
import {cartTotal} from "../config/react.vars";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QUERY_GET_PRODUCTS = gql`
        query getProducts($ids: String){
        getProducts(ids: $ids){
            id
            title
            pricein
            preview
            barcode
            id_presence

        }
    }
    `;

const AppCartMain = () => {

    // let storageItems = localStorage.getItem('cartItems');
    // let itemsList = [];

    const [itemsList, setItemsList] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [idsProducts, setIdsProducts] = useState([]);

    //const cartTtl = useReactiveVar(cartTotal);
    //console.log("******* обновление CART ITEMS ********");

    useEffect(() => {
        //console.log('Before storageItems');
        let storageItems = localStorage.getItem('cartItems')??'[]';
        //console.log('Load storageItems', storageItems);

        let storage = [];
        try {
            storage = JSON.parse(storageItems);
            //console.log('parsed storageItems', storageItems);
        }catch (e){
            setItemsList([]);
        }

        let ids = [];

        let items = [];

        if(storage){
            storage.forEach((el) => {
                if (el.count<=0){
                    el.checked=0;
                }
                items.push(el);
                ids.push(el.id);
            })
        }else {
            //console.log("storage is null");
        }

        //console.log('Loaded Items: ', items, 'ids: ', ids);

        setItemsList(items);
        setIdsProducts(ids);

    }, [])



    let ids = JSON.stringify(idsProducts);
    const [getQueryProducts, {
        loading: prodLoading,
        error: prodError,
        data: prodData,
        called: prodCalled
    }] = useLazyQuery(QUERY_GET_PRODUCTS, {notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only', variables: {ids: ids, public:true }});



    useEffect(() => {
        //if (idsProducts.length) {
            //console.log('RUN ===========> getQueryProducts', ids);
            getQueryProducts();
        //}else{
        //    console.log('BREAK ===========> getQueryProducts', ids);
        //}
    }, [ids])



    useEffect(() => {
        if (!prodLoading) {
            let _orderList = [];
            if (!prodError) {
                if (prodData && prodData.getProducts) {
                    let itemsIdList = [];
                    prodData.getProducts.forEach((currentVal, index) => {

                        //console.log('curVal',currentVal);
                        let idx = null;
                        itemsList.every((el, index) => {
                            if ((el.id).toString() === (currentVal.id).toString()) {
                                idx = index;
                                return false;
                            }
                            return true;
                        });

                        // if (!itemsList[idx]) {
                        //     return false
                        // }

                        let count = itemsList[idx]?.count ?? 0
                        // если был найден товар, которого не было вернуть количество 0 вместо -1
                        if(count < 0) count = 0;
                        //console.log('put item ' + idx);
                        itemsIdList.push(itemsList[idx]?.id);
                        _orderList.push({
                            id: currentVal.id,
                            title: currentVal.title,
                            count: count,
                            price: currentVal.pricein,
                            total: currentVal.pricein * count,
                            barcode: currentVal.barcode,
                            preview: currentVal.preview,
                            id_presence: currentVal.id_presence,
                            checked: itemsList[idx]?.checked ?? true,
                            blackout: false
                        });
                    }, [])


                    // то что осталось в списке - нужно пометить как заблокированное
                    itemsList.every( (listItem) => {
                        let foundIdx = -1;

                        // поиск среди уже добавленных id
                        itemsIdList.every( (item, index)=>{
                            if((listItem.id).toString() === (item).toString()){
                                foundIdx = index;
                                return false;
                            }
                            return true;
                        })

                        // если id не найден - значит такого товара уже нет в продаже
                        if(foundIdx === -1){
                            listItem.checked = false;
                            listItem.count=-1;
                            _orderList.push({
                                id: listItem.id,
                                title: listItem.title,
                                count: -1,
                                price: listItem.price,
                                total: 0,
                                barcode: '',
                                preview: '',
                                id_presence: 0,
                                checked: false,
                                blackout: true
                            })
                        }
                    })

                    setOrderList(_orderList);

                    // пересохранить список товаров
                    //console.log('reSave itemList',itemsList);
                    //console.log('reSave orderList',_orderList);

                    const evt = new StorageEvent('storage',{
                        key:'items',
                        oldValue:'oldValue',
                        newValue:'newValue',
                        url:null,
                        storageArea:window.localStorage
                    });

                    localStorage.setItem('cartItems', JSON.stringify(itemsList));
                    window.dispatchEvent(evt);

                }
            }else{
                //console.log(' doesnt exists', prodError.message, prodError.graphQLErrors );

                let errors = prodError.graphQLErrors;
                let markAllDisabled = false;
                if(errors){
                    let error  = errors[0];
                    // при этой ошибке пометить все товары как отсутствующие в продаже
                    if((error?.extensions?.category === 'fields') && (error?.extensions?.code === '400')){
                        markAllDisabled = true;
                    }
                }

                if(markAllDisabled){
                    let itemsIDs = JSON.parse(ids);
                    //console.log(itemsIDs);
                    itemsIDs.every( (el) => {
                        //console.log('add blocked item ', el);
                        itemsList.every( (listItem) => {
                            listItem.checked = false;
                            listItem.count=-1;
                            if(el.toString() === listItem.id.toString()){
                                //console.log('push orderList',listItem.id);
                                _orderList.push({
                                    id: listItem.id,
                                    title: listItem.title,
                                    count: -1,
                                    price: listItem.price,
                                    total: 0,
                                    barcode: '',
                                    id_presence: 0,
                                    preview: '',
                                    checked: false,
                                    blackout: true
                                });
                                return false;
                            }
                            return true;
                        })
                        return true;
                    })
                    setOrderList(_orderList);
                }

                //пересохранить список товаров

            }
        }
    }, [prodLoading]);

    const getCountChecked = (_list) => {
        let retCount = 0;
        _list.every( (val) => {
            if((val?.count > -1) && (val?.checked)){
                retCount = retCount + 1;
            }
            return true;
        })
        return retCount;
    }

    const getCountAll = (_list) => {
        let retCount = 0;
        _list.every( (val) => {
            if(val?.count > -1){
                retCount = retCount + 1;
            }
            return true;
        })
        return retCount;
    }

    const [itemsTotalPrice, setItemsTotalPrice] = useState(null);
    const [totalPrice, setTotalPrice] = useState(null);

    const [checkedAll, setCheckedAll] = useState(true);
    const [countChecked, setCountChecked] = useState(getCountAll(itemsList));



    // удалить товар из корзины
    const deleteItem = (index) => {
        const newItems = itemsList.filter((item) => (item.id).toString() !== (index).toString());

        setItemsList(newItems);

        /////////////////////////////
        let newOrderList = orderList.filter((item) => (item.id).toString() !== (index).toString());
        setOrderList(newOrderList);
        /////////////////////////////

        const evt = new StorageEvent('storage',{
            key:'items',
            oldValue:'oldValue',
            newValue:'newValue',
            url:null,
            storageArea:window.localStorage
        });

        localStorage.setItem('cartItems', JSON.stringify(newItems));
        window.dispatchEvent(evt);
    }


    // выбрать элемент и установить checkbox
    const changeCheck = (index) => {
        let checkedCount = 0;

        let newArr = itemsList.map((item) => {
            if(item.count > -1){
                if ((item.id).toString() === (index).toString()) {
                    item.checked = !item.checked;
                }
                if (item.checked) checkedCount++;
            }
            return item;
        });
        /////////////////////////////
        let newOrderList = orderList.map((item, i) => {
            if(item.count > -1){
                if ((item.id).toString() === (index).toString()) {
                    item.checked = !item.checked;
                }
            }
            return item;
        })
        setOrderList(newOrderList);
        /////////////////////////////

        setItemsList(newArr);

        if (checkedCount === getCountAll(itemsList)) {
            setCheckedAll(true);
        }else {
            setCheckedAll(false);
        }

    }

    // высчитываем информацию для правого блока и устанавливаем её
    useEffect(() => {
        let itemsPrice = 0;
        let countChecked = 0;
        itemsList.map((item) => {
            item.total = item.price * item.count;
            if(item.count>-1){
                if (item.checked) {
                    itemsPrice += item.total;
                    countChecked += +item.count;
                } else {
                    setCheckedAll(false);
                }
            }

        })

        setCountChecked(countChecked);
        setItemsTotalPrice(itemsPrice);
        setTotalPrice(itemsPrice);

    })

    /*
    useEffect( () => {
        cartTotal(countChecked);
    },[countChecked]);
    */

    //перезаписываем в localStorage товары
    useEffect(() => {
        // console.log('itemsListitemsListitemsListitemsListitemsListitemsListitemsListitemsList');
        // console.log(itemsList);
        localStorage.setItem('cartItems', JSON.stringify(itemsList));
        //
        // // оправляем событие для уведомления об изменении localStorage
        const evt = new StorageEvent('storage',{
            key:'items',
            oldValue:'oldValue',
            newValue:'newValue',
            url:null,
            storageArea:window.localStorage
        });

        window.dispatchEvent(evt);
    })

    // установить или убрать выделение со всех элементов
    const changeAllCheck = (e) => {
        let status = !checkedAll;
        let checkedCount = 0;
        let newArr = itemsList.map((item, i) => {
            if(item.count > -1){
                item.checked = status;
                checkedCount = checkedCount + 1;
            }else{
                item.checked = false;
            }
            return item;
        })

        /////////////////////////////
        let newOrderList = orderList.map((item, i) => {
            if(item.count > -1){
                item.checked = status;
            }else{
                item.checked = false;
            }
            return item;
        })
        setOrderList(newOrderList);
        /////////////////////////////


        setCheckedAll(status);
        setItemsList(newArr);

        if (status)
            setCountChecked(checkedCount);
        else
            setCountChecked(0);
    }

    //изменить количество товара
    const changeItem = (val, index) => {
        console.log('changeItem', val, index );
        let absoluteValue = val;
        let newArr = itemsList.map((item) => {
            console.log('item:', item, val);
            if ((item.id).toString() === (index).toString()) {
                console.log('found item', item.id);
                if(item.count > -1){
                    // только для тех, кто в наличии в списке товаров можно менять количество
                    orderList.every((val) => {
                        if((val.id === item.id)&&(val.id_presence === 1)){
                            item.count = absoluteValue;
                            return false;
                        }
                        return true;
                    })
                    item.checked = Boolean(item.count>0);
                }else{
                    item.checked = false;
                }
            }
            return item;
        })

        /////////////////////////////

        let newOrderList = orderList.map((item, i) => {
            if ((item.id).toString() === (index).toString()) {
                if(item.count > -1){
                    //console.log('id_pesence', item.id_presence);
                    // только для тех, кто в наличии можно менять количество
                    if(item.id_presence === 1) {
                        item.count = val;
                        item.total = item.count * item.price;
                    }
                    // так как пользователю разрешается ввести 0, то автоматом отключаем эту запись
                    // иначе запиь с нулем попадет в список на оформление
                    item.checked = Boolean(item.count>0);
                }else{
                    item.checked = false;
                }
            }
            return item;
        })
        setOrderList(newOrderList);
        /////////////////////////////
        setItemsList(newArr);
    }

    return (
        <div>
            <div className="container-xxl px-md-6">
                
                <h1 className="mb-8">
                    <a className="text-muted" href="/"><FontAwesomeIcon icon={faChevronLeft} className='me-3'/></a>
                    <span>Корзина</span>
                </h1>
                {((!prodLoading) &&(prodCalled))?(
                <section className="mb-10">
                    {itemsList.length > 0 &&
                        <div className="form-check mb-4">
                            <input className="form-check-input" type="checkbox" value="" id="check_all"
                                   checked={checkedAll}
                                   onChange={changeAllCheck}/>
                            <label className="form-check-label" htmlFor="check_all">
                                Выбрать все
                            </label>
                        </div>
                    }
                    <div className="row gx-0 border-top">
                        <div className="col-md-7 col-lg-8 pe-md-6">
                            {itemsList.length > 0 ? (
                                <div>
                                    {orderList.map((item, index) => {
                                        return (
                                            <AppCartItem
                                                key={item.id}
                                                data={item}
                                                changeItem={changeItem}
                                                changeCheck={changeCheck}
                                                decreaseCount={changeItem}
                                                increaseCount={changeItem}
                                                deleteItem={deleteItem}
                                            />
                                        )
                                    })}
                                    <hr className="m-0"/>
                                </div>
                            ): (
                                <div className="my-6">
                                    Ваша корзина пуста, добавьте товары которые вам нравятся из <a className="text-muted" href="/search">каталога</a>
                                </div>
                            )}
                        </div>
                        <div className="col-md-5 col-lg-4">
                            { (getCountAll(itemsList) > 0) ? (
                                <AppCartInfo
                                    count={countChecked}
                                    itemsTotalPrice={itemsTotalPrice}
                                    totalPrice={totalPrice}
                                    changeAllCheck={changeAllCheck}
                                />
                            ):(
                                <div className="position-relative bg-light h-100">
                                    <div className="position-sticky p-6 top-0">
                                        В корзине на данный момент нет товаров, доступных для оформления заказа. Добавьте в корзину товары из <a className="text-muted" href="/search">каталога</a>
                                    </div>
                                </div>

                                )}
                        </div>
                    </div>
                </section>):(
                    <div className="mb-10 placeholder-wave">
                        <div className="mb-4">
                            <div className="rounded-4 placeholder" style={{width:'160px',height:'20px'}}></div>
                        </div>
                        <h1 className="mb-4 rounded-4 placeholder w-50" style={{height:"32px"}}></h1>
                        <div className="mb-5">
                            <div className="rounded-4 placeholder" style={{width:"200px",height:"20px"}}></div>
                        </div>
                        <div className="card rounded-4 w-100 placeholder" style={{height:"120px"}}></div>
                    </div>
                    )}
            </div>
        </div>
    );
}

export default AppCartMain;
